"use strict";
/**
 * Reducer slice for `*_FIELD*` and `*_MAPPING*` actions. Owns the fields
 * list and the mapping rows nested inside each field.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldReducer = exports.isFieldAction = void 0;
var ai_hub_settings_client_ids_1 = require("./ai-hub-settings-client-ids");
var ai_hub_settings_utils_1 = require("./ai-hub-settings-utils");
var ai_hub_settings_reducer_helpers_1 = require("./ai-hub-settings-reducer-helpers");
exports.isFieldAction = function (action) {
    switch (action.type) {
        case 'ADD_FIELD':
        case 'DELETE_FIELD':
        case 'DISCARD_FIELD_EDIT':
        case 'UPDATE_FIELD_NAME':
        case 'TOGGLE_FIELD_IGNORE':
        case 'ADD_MAPPING':
        case 'REMOVE_MAPPING':
        case 'MAPPING_ACTION':
        case 'SET_SELECTED_FIELD':
            return true;
        default:
            return false;
    }
};
var addField = function (state) {
    var newField = ai_hub_settings_utils_1.createEmptyField();
    var newId = newField.__clientId;
    return __assign(__assign({}, state), { draft: __assign(__assign({}, state.draft), { fields: __spreadArrays([newField], state.draft.fields) }), newFieldIds: __spreadArrays([newId], state.newFieldIds), selectedFieldId: newId });
};
var deleteField = function (state, action) {
    var index = ai_hub_settings_client_ids_1.findFieldIndexById(state.draft.fields, action.clientId);
    if (index < 0) {
        return state;
    }
    return __assign(__assign({}, state), { draft: __assign(__assign({}, state.draft), { fields: ai_hub_settings_reducer_helpers_1.removeAt(state.draft.fields, index) }), newFieldIds: state.newFieldIds.filter(function (id) { return id !== action.clientId; }), selectedFieldId: state.selectedFieldId === action.clientId ? null : state.selectedFieldId });
};
var discardFieldEdit = function (state, action) {
    var isNew = state.newFieldIds.indexOf(action.clientId) >= 0;
    var draftIndex = ai_hub_settings_client_ids_1.findFieldIndexById(state.draft.fields, action.clientId);
    if (draftIndex < 0) {
        return state;
    }
    var clearSelection = state.selectedFieldId === action.clientId ? { selectedFieldId: null } : null;
    if (isNew) {
        return __assign(__assign(__assign({}, state), (clearSelection || {})), { draft: __assign(__assign({}, state.draft), { fields: ai_hub_settings_reducer_helpers_1.removeAt(state.draft.fields, draftIndex) }), newFieldIds: state.newFieldIds.filter(function (id) { return id !== action.clientId; }) });
    }
    var savedIndex = ai_hub_settings_client_ids_1.findFieldIndexById(state.saved.fields, action.clientId);
    if (savedIndex < 0) {
        return state;
    }
    return __assign(__assign(__assign({}, state), (clearSelection || {})), { draft: ai_hub_settings_reducer_helpers_1.withFieldReplaced(state.draft, draftIndex, ai_hub_settings_utils_1.cloneAiHubSettingsField(state.saved.fields[savedIndex])) });
};
var updateFieldName = function (state, action) {
    var index = ai_hub_settings_client_ids_1.findFieldIndexById(state.draft.fields, action.clientId);
    if (index < 0) {
        return state;
    }
    return __assign(__assign({}, state), { draft: ai_hub_settings_reducer_helpers_1.withFieldReplaced(state.draft, index, __assign(__assign({}, state.draft.fields[index]), { name: action.name })) });
};
var toggleFieldIgnore = function (state, action) {
    var index = ai_hub_settings_client_ids_1.findFieldIndexById(state.draft.fields, action.clientId);
    if (index < 0) {
        return state;
    }
    return __assign(__assign({}, state), { draft: ai_hub_settings_reducer_helpers_1.withFieldReplaced(state.draft, index, __assign(__assign({}, state.draft.fields[index]), { ignore: action.ignore })) });
};
var addMapping = function (state, action) {
    var index = ai_hub_settings_client_ids_1.findFieldIndexById(state.draft.fields, action.fieldId);
    if (index < 0) {
        return state;
    }
    var next = __assign(__assign({}, state.draft.fields[index]), { mapping: __spreadArrays(state.draft.fields[index].mapping, [ai_hub_settings_utils_1.createEmptyFieldMapping()]) });
    return __assign(__assign({}, state), { draft: ai_hub_settings_reducer_helpers_1.withFieldReplaced(state.draft, index, next) });
};
var removeMapping = function (state, action) {
    var fieldIndex = ai_hub_settings_client_ids_1.findFieldIndexById(state.draft.fields, action.fieldId);
    if (fieldIndex < 0) {
        return state;
    }
    var field = state.draft.fields[fieldIndex];
    var mappingIndex = ai_hub_settings_client_ids_1.findMappingIndexById(field.mapping, action.mappingId);
    if (mappingIndex < 0) {
        return state;
    }
    return __assign(__assign({}, state), { draft: ai_hub_settings_reducer_helpers_1.withFieldReplaced(state.draft, fieldIndex, __assign(__assign({}, field), { mapping: ai_hub_settings_reducer_helpers_1.removeAt(field.mapping, mappingIndex) })) });
};
var mappingAction = function (state, action) {
    var fieldIndex = ai_hub_settings_client_ids_1.findFieldIndexById(state.draft.fields, action.fieldId);
    if (fieldIndex < 0) {
        return state;
    }
    var field = state.draft.fields[fieldIndex];
    var mappingIndex = ai_hub_settings_client_ids_1.findMappingIndexById(field.mapping, action.mappingId);
    if (mappingIndex < 0) {
        return state;
    }
    var nextMapping = ai_hub_settings_reducer_helpers_1.applyMappingAction(field.mapping[mappingIndex], action.action);
    return __assign(__assign({}, state), { draft: ai_hub_settings_reducer_helpers_1.withFieldReplaced(state.draft, fieldIndex, __assign(__assign({}, field), { mapping: ai_hub_settings_reducer_helpers_1.replaceAt(field.mapping, mappingIndex, nextMapping) })) });
};
exports.fieldReducer = function (state, action) {
    switch (action.type) {
        case 'SET_SELECTED_FIELD':
            return state.selectedFieldId === action.clientId
                ? state
                : __assign(__assign({}, state), { selectedFieldId: action.clientId });
        case 'ADD_FIELD':
            return addField(state);
        case 'DELETE_FIELD':
            return deleteField(state, action);
        case 'DISCARD_FIELD_EDIT':
            return discardFieldEdit(state, action);
        case 'UPDATE_FIELD_NAME':
            return updateFieldName(state, action);
        case 'TOGGLE_FIELD_IGNORE':
            return toggleFieldIgnore(state, action);
        case 'ADD_MAPPING':
            return addMapping(state, action);
        case 'REMOVE_MAPPING':
            return removeMapping(state, action);
        case 'MAPPING_ACTION':
            return mappingAction(state, action);
        default:
            return state;
    }
};
